import React, { FC } from "react";

import { useLocation } from "react-router";

import { dataAttrGUI } from "@at/formatter-utils/lib/data-attr-utils/data-attr-utils";

import { deconstructLeaseTerms } from "@at/leasing-utils";

import { OrderButton } from "./leasing-order-button.styled";
import { LeaseContractType } from "../../../../../__generated__/graphql-types";
import {
  useLeasingDispatchContext,
  useLeasingStateContext,
} from "../../../../../contexts/leasing/context/leasing.context";
import { ELeasingBusinessType } from "../../../../../contexts/leasing/types/leasing.types";
import { useChannel } from "../../../../../utils/hooks/use-channel";
import { scrollToId } from "../../../../../utils/scrolling";
import { useTracking } from "../../../../../utils/tracking/use-tracking";
import {
  buildNewQueryString,
  buildUrlWithParams,
} from "../../../navigation/leasing-navigation.utils";

export const LeasingOrderButton: FC = () => {
  const {
    selectedLeaseOffer,
    productData,
    leaseOption,
    leaseContractType,
    selectedBusinessType,
    leaseOffersData,
  } = useLeasingStateContext();
  const routerLocation = useLocation();
  const windowLocation = typeof window !== undefined && window.location;
  const { search } = windowLocation || routerLocation;
  const { trackEvent } = useTracking();
  const dispatch = useLeasingDispatchContext();
  const channel = useChannel();
  const leaseOffersAvailable = !!leaseOffersData?.length;

  const isBusinessAndDefault =
    leaseContractType === LeaseContractType.business &&
    selectedBusinessType === ELeasingBusinessType.DEFAULT;

  const newSearchString = buildNewQueryString(
    search,
    productData?.id,
    leaseContractType,
    selectedLeaseOffer,
    leaseOption,
  );

  const urlWithParams = buildUrlWithParams(
    newSearchString,
    `/${channel}/leasing/checkout/create`,
  );

  const monthlyPrice =
    selectedLeaseOffer?.[
      leaseContractType === LeaseContractType.business
        ? "monthlyPriceExVat"
        : "monthlyPrice"
    ];

  const { depositMultiple } = { ...deconstructLeaseTerms(leaseOption) };

  const calculatedDeposit =
    depositMultiple && monthlyPrice ? depositMultiple * monthlyPrice : null;

  return (
    <OrderButton
      text={"Start application"}
      trackingCallback={() => trackEvent({ trackingLabel: "order-online" })}
      onInteraction={() => {
        if (!leaseOffersAvailable) {
          scrollToId("payment-customiser", { block: "center" });
        }
        if (selectedBusinessType === ELeasingBusinessType.DEFAULT) {
          trackEvent({
            trackingLabel: "leasing-business-company-selection-error",
          });
          dispatch({ type: "SET_BUSINESS_TYPE_ERROR", payload: true });
          scrollToId("business-type", { block: "center" });
        }
      }}
      url={
        selectedLeaseOffer && calculatedDeposit && !isBusinessAndDefault
          ? urlWithParams
          : undefined
      }
      fullWidth={true}
      type="button"
      {...{ attributes: { [dataAttrGUI]: "start-leasing-order-button" } }}
    />
  );
};
